const STORAGE_PREFIX = 'nc_lastStarter_';

/** Who opens the next local game (Pass & Play / vs AI). */
export function starterStorageKey(categoryMode, lobbyName = '') {
  const mode = String(categoryMode ?? '').trim();
  if (mode === 'pvp') {
    const lobby = String(lobbyName ?? '').trim();
    return `${STORAGE_PREFIX}pvp_${lobby || 'default'}`;
  }
  if (mode === 'Pass & Play' || mode === 'pass-play' || mode === 'passplay') {
    return `${STORAGE_PREFIX}offline`;
  }
  if (mode === 'ai' || mode === 'vs-ai') {
    return `${STORAGE_PREFIX}ai`;
  }
  return `${STORAGE_PREFIX}${mode || 'default'}`;
}

/**
 * Next starting player for a new local game.
 * First game defaults to X; then alternates X → O → X …
 */
export function getNextStartingPlayer(storageKey) {
  try {
    const last = sessionStorage.getItem(storageKey);
    const next = last === 'X' ? 'O' : 'X';
    sessionStorage.setItem(storageKey, next);
    return next;
  } catch {
    return 'X';
  }
}

/** Lobby rematch: rematchSeq 0 → X, 1 → O, 2 → X, … */
export function startingPlayerForRematchSeq(rematchSeq) {
  const seq = Number(rematchSeq) || 0;
  return seq % 2 === 0 ? 'X' : 'O';
}

/** Next rematch index when presenter starts from waiting (no active board). */
export function nextRematchSeqForLobbyStart(existingData) {
  const prev = Number(existingData?.shiftGameRematchSeq) || 0;
  const board = existingData?.shiftGameState?.board;
  const hasBoard = Array.isArray(board) && board.length === 9;
  if (!hasBoard) return 0;
  const state = existingData.shiftGameState;
  if (state?.winner || state?.isDraw) return prev + 1;
  return prev;
}
